(function () {
  'use strict';

  function parseVariantMap(str) {
    var map = {};
    if (!str) return map;
    str.split(';').forEach(function (entry) {
      entry = entry.trim();
      if (!entry) return;
      var eq = entry.indexOf('=');
      if (eq < 0) return;
      var key = entry.slice(0, eq);
      var rest = entry.slice(eq + 1);
      var colon = rest.indexOf(':');
      if (colon < 0) return;
      map[key] = {
        id: rest.slice(0, colon),
        available: rest.slice(colon + 1) === '1',
      };
    });
    return map;
  }

  function getState(wrapper) {
    var color = wrapper.querySelector('.ls-swatch.is-selected');
    var size = wrapper.querySelector('.ls-size-pill.is-selected');
    return {
      color: color ? color.dataset.color : null,
      size: size ? size.dataset.size : null,
    };
  }

  function setReady(wrapper, ready) {
    var wrap = wrapper.querySelector('[data-ls-atc-wrap]');
    if (!wrap) return;
    if (ready) wrap.setAttribute('data-ls-ready', '1');
    else wrap.removeAttribute('data-ls-ready');
  }

  function refresh(wrapper) {
    if (!wrapper) return;
    var data = wrapper.querySelector('[data-ls-variant-map]');
    if (!data) return;
    var map = wrapper.__lsMap;
    if (!map) {
      map = parseVariantMap(data.dataset.lsVariantMap);
      wrapper.__lsMap = map;
    }
    var st = getState(wrapper);
    var btn = wrapper.querySelector('[data-ls-atc]');
    var label = wrapper.querySelector('[data-ls-atc-label]');
    if (!btn || !label) return;

    var hasColorOpt = !!wrapper.querySelector('.card__ls-swatches');
    var hasSizeOpt = !!wrapper.querySelector('.card__ls-sizes');

    var needsColor = hasColorOpt && !st.color;
    var needsSize = hasSizeOpt && !st.size;

    // Hide the ATC wrapper entirely until the user picks all required options.
    if (needsColor || needsSize) {
      setReady(wrapper, false);
      btn.disabled = true;
      if (needsColor && needsSize) label.textContent = 'Selecciona color y talla';
      else if (needsColor) label.textContent = 'Selecciona un color';
      else label.textContent = 'Selecciona una talla';
      return;
    }

    var key = (st.color || '') + '|' + (st.size || '');
    var match = map[key];
    if (!match) {
      Object.keys(map).some(function (k) {
        var parts = k.split('|');
        if ((!hasColorOpt || parts[0] === st.color) &&
            (!hasSizeOpt || parts[1] === st.size)) {
          match = map[k];
          return true;
        }
      });
    }

    if (!match) {
      setReady(wrapper, true);
      btn.disabled = true;
      label.textContent = 'No disponible';
      return;
    }

    btn.dataset.variantId = match.id;
    if (!match.available) {
      setReady(wrapper, true);
      btn.disabled = true;
      label.textContent = 'Agotado';
      return;
    }

    setReady(wrapper, true);
    btn.disabled = false;
    label.textContent = 'Agregar al carrito';
  }

  function replaceSection(sectionName, html) {
    if (!html) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var wrapper = doc.getElementById('shopify-section-' + sectionName) || doc.body.firstElementChild;
    if (!wrapper) return;

    if (sectionName === 'cart-drawer') {
      // Live DOM has <cart-drawer> at body level (no shopify-section wrapper).
      // Extract the fresh <cart-drawer> from the response and swap it in.
      var freshDrawer = wrapper.querySelector('cart-drawer');
      var liveDrawer = document.querySelector('cart-drawer');
      if (freshDrawer && liveDrawer) {
        liveDrawer.innerHTML = freshDrawer.innerHTML;
        // Copy is-empty / active class state from response's outer classes
        if (freshDrawer.classList.contains('is-empty')) {
          liveDrawer.classList.add('is-empty');
        } else {
          liveDrawer.classList.remove('is-empty');
        }
      }
      return;
    }

    if (sectionName === 'cart-icon-bubble') {
      var freshBubble = wrapper.querySelector('#cart-icon-bubble') || wrapper.querySelector('.shopify-section > *') || wrapper.firstElementChild;
      var liveBubble = document.getElementById('cart-icon-bubble');
      if (freshBubble && liveBubble) {
        liveBubble.innerHTML = freshBubble.innerHTML || freshBubble.outerHTML;
      }
      return;
    }

    // Generic: try to find element with same id and swap innerHTML
    var host = document.getElementById(sectionName);
    if (host && wrapper) host.innerHTML = wrapper.innerHTML;
  }

  function refreshCartDrawer() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var url = '/?sections=' + encodeURIComponent(sections.join(','));
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        sections.forEach(function (name) {
          if (json[name]) replaceSection(name, json[name]);
        });
        // Also refresh cart notification section if present
        var noti = document.querySelector('cart-notification');
        if (noti) {
          fetch('/?sections=cart-notification')
            .then(function (r) { return r.json(); })
            .then(function (j) { if (j['cart-notification']) replaceSection('cart-notification', j['cart-notification']); })
            .catch(function () {});
        }
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // Dawn's cart-drawer.open() opens the drawer and sets aria/focus
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) {}
    }
    // Fallback: mimic what open() does
    drawer.classList.add('active', 'animate');
    drawer.classList.remove('is-empty');
    drawer.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  function addToCart(btn) {
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var labelEl = btn.querySelector('.ls-atc-btn__label');
    var origLabel = labelEl ? labelEl.textContent : '';
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Agregando…';

    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (json) {
        // Update cart sections from the /cart/add.js response
        if (json && json.sections) {
          Object.keys(json.sections).forEach(function (name) {
            replaceSection(name, json.sections[name]);
          });
        } else {
          // Fallback: fetch sections separately
          return refreshCartDrawer();
        }
      })
      .then(function () {
        openCartDrawer();
        if (labelEl) labelEl.textContent = 'Agregado ✓';
        setTimeout(function () {
          if (labelEl) labelEl.textContent = origLabel;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        console.error('[LSCard] add-to-cart failed', err);
        if (labelEl) labelEl.textContent = (err && err.description) || 'Error al agregar';
        setTimeout(function () {
          if (labelEl) labelEl.textContent = origLabel;
          btn.disabled = false;
        }, 2000);
      });
  }

  function isHoverCapable() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function dedupeAndReorganize(w) {
    // The theme renders card-product with TWO card__content blocks (first inside
    // card__inner, second below). One is hidden depending on settings.card_style
    // ("card" hides the second; "standard" hides the first). Our snippet renders
    // inside both — so we keep the LAST occurrence (which is in the visible
    // second card__content for "standard" style, the theme's default).
    ['[data-ls-variant-map]', '.card__ls-swatches', '.card__ls-sizes', '[data-ls-atc-wrap]'].forEach(function (sel) {
      var nodes = w.querySelectorAll(sel);
      for (var i = 0; i < nodes.length - 1; i++) nodes[i].remove();
    });
    // On DESKTOP (hover-capable) — move pills into .card__media as an overlay
    // that reveals on hover. On MOBILE/TOUCH — leave them where the snippet put
    // them (in the card body below the swatches), where they render as a single
    // horizontal row inline in the flow of the card body.
    var sizes = w.querySelector('.card__ls-sizes');
    if (!sizes) return;
    var cardMedia = w.querySelector('.card__media');
    if (isHoverCapable() && cardMedia && sizes.parentElement !== cardMedia) {
      cardMedia.appendChild(sizes);
    }
  }

  // If the viewport changes device class between mobile/desktop (e.g. via
  // resize or device rotation), re-run the layout decision so pills end up in
  // the right container.
  if (window.matchMedia) {
    try {
      window.matchMedia('(hover: hover) and (pointer: fine)').addEventListener('change', function () {
        document.querySelectorAll('.card-wrapper').forEach(function (w) {
          w.dataset.lsInit = '';
        });
        initAll();
      });
    } catch (e) {}
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.card-wrapper').forEach(function (w) {
      if (w.dataset.lsInit === '1') return;
      var hasVariantUi = w.querySelector('[data-ls-variant-map]');
      if (!hasVariantUi) return;
      w.dataset.lsInit = '1';
      dedupeAndReorganize(w);
      refresh(w);
    });
  }

  window.LSCard = { refresh: refresh, addToCart: addToCart, init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
